import React from "react";
import BackgroundCover from "../../components/backgroundCover/BackgroundCover";
import TitleWithDescription from "../../components/TitleWithDescription/TitleWithDescription";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import Title from "../../components/Title/Title";
import ImageWithFallback from "../../components/ImageWithFallback/ImageWithFallback";
import { useLanguage } from "../../context/LanguageContext";
import { tourmalinesTranslations } from "../../translations/tourmalinesTemplate";

function Tourmaline() {
  const imagePrefix = "tourmaline";
  const { language } = useLanguage();
  const t = tourmalinesTranslations[language];

  return (
    <div className="">
      <BackgroundCover
        backgroundHeight={300}
        imagePosition="initial"
        backgroundImage={`/images/${imagePrefix}_background.jpg`}
      >
        <div className="absolute top-1/2 left-[10%] -translate-y-1/2 z-10 hidden md:block">
          <Title
            firstLine={t.firstLine}
            secondLine={<><span className="text-3xl mr-2">{t.secondLine}</span></>}
            className="text-white"
            animate={true}
          />
        </div>
      </BackgroundCover>

      <div className="mx-auto px-4 md:px-0">
        <div className="block md:hidden mb-8">
          <Title
            firstLine={t.firstLine}
            secondLine={<><span className="text-3xl mr-2">the</span><strong>{t.secondLine}</strong></>}
            className=""
            animate={true}
          />
        </div>
      </div>

      <div className="w-full bg-gradient-to-b from-gray-100 to-gray-200">
        <video
          src="/video/tourmaline.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="w-full max-w-none"
        />
      </div>
      <div className="relative w-full overflow-hidden">
        <div className="w-full bg-gradient-to-b from-[#E1D8D3] via-[#FFFFFF] to-[#E1D8D3] py-12">
          <div className="mx-auto px-4 md:px-0">
            <div className="mx-auto px-4 md:px-0 pt-8 space-y-12 max-w-7xl">
              <TimelineSection
                title={{
                  firstLine: t.section1.firstLine,
                  secondLine: t.section1.secondLine,
                }}
                description={t.section1.description.join('\n\n')}
                media={{
                  type: 'image',
                  src: `/images/tourmalines_sub_1.jpg`,
                  alt: "Viking Compass"
                }}
                mediaPosition="right"
              />

              <TimelineSection
                title={{
                  firstLine: t.section2.firstLine,
                  secondLine: t.section2.secondLine,
                }}
                description={t.section2.description.join('\n\n')}
                media={{
                  type: 'image',
                  src: `/images/tourmalines_sub_2.jpg`,
                  alt: "Symbolic Meaning"
                }}
                mediaPosition="left"
                showLine={false}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tourmaline;